import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {withRouter} from 'react-router-dom';
import ActionCreator from "../../../store/actions/index";
import {withStyles} from "@material-ui/core";
import {compose} from 'recompose';
import Button from '@material-ui/core/Button';
import TrackChangesIcon from '@material-ui/icons/TrackChanges';
import DateTimePicker from "./DateTimePicker";
import {themeTypeToBool} from '../../../utils/helpers';
import Filter from "../../Filters/Filter";
import FiltersBar from "../../Filters/FiltersBar";
import t from "../../../languages/pl";
import {isNullOrEmpty} from '../../../utils/helpers';
import {generateMapForCars} from '../CarList/exportMap';
import moment from 'moment-timezone';
import {displayDateTimeFormat, typeRefuel, typeRoute} from '../../../utils/staticData';
import MapIcon from '@material-ui/icons/Map';

const TopBar = (props) => {
    const {
        classes,
        selectedCar,
        cars,
        trackAll,
        searchField,
        filteredCars,
        zoom,
        center,
        selectedRoutes,
        routes,
        currentRoute,
        showCurrentRoute
    } = props;


    const handleTrackAllCars = () => {
        props.setSearchField("");
        props.getCarsForMap();
        props.trackAllCars();
        props.clearRoutes();
        props.history.push("/map");
        if (!selectedCar)
            props.mapToBounds(cars);
    };

    const handleExportMap = () => {
        const element = document.createElement('a');
        let properties = [];
        let generatedMap;
        if (selectedCar) {
            let routesToExport = [];
            let refuelsToExport = [];
            let currentRouteToExport = {};
            if (selectedRoutes) {
                const allRoutes = selectedRoutes.filter(route => route.type === typeRoute);
                const refuels = routes.filter(route => route.type === typeRefuel && route.selected);

                routesToExport = allRoutes.map(route => ({
                    id: route.id,
                    startDate: moment.unix(route.data_od).format(displayDateTimeFormat),
                    endDate: moment.unix(route.data_do).format(displayDateTimeFormat),
                    driver: route.kierowca,
                    distance: route.dystans,
                    maxSpeed: route.predkosc_max,
                    averageSpeed: route.predkosc_sr,
                    selected: route.selected,
                    route: route.trasa,
                    timeDiffInSeconds: (moment.unix(route.data_do).toDate().getTime() - moment.unix(route.data_od).toDate().getTime()) / 1000,
                }));
                refuelsToExport = refuels.map(refuel => ({
                    id: refuel.id,
                    date: moment.unix(refuel.data).format(displayDateTimeFormat),
                    lat: refuel.lat,
                    lon: refuel.lon,
                    liters: refuel.litry,
                    selected: refuel.selected
                }));
            }
            if (currentRoute && showCurrentRoute) {
                currentRouteToExport = {
                    route: currentRoute.data,
                    startDate: moment.unix(currentRoute.data[0].data_od).format(displayDateTimeFormat),
                    driver: currentRoute.data[0].kierowca,
                    distance: currentRoute.data[0].dystans,
                    maxSpeed: currentRoute.data[0].predkosc_max,
                    averageSpeed: currentRoute.data[0].predkosc_sr,
                    selected: showCurrentRoute,
                };
            }
            properties = {
                cars: [{
                    pozycja_gps: selectedCar.pozycja_gps,
                    rejestracja: selectedCar.rejestracja,
                    marka: selectedCar.marka,
                    model: selectedCar.model,
                    stanPaliwa: selectedCar.stan_paliwa,
                    stanPaliwaProcent: Math.round(selectedCar.stan_paliwa_procent * 100),
                    typPaliwa: selectedCar.paliwo,
                    ostatniaAktualizacja: moment.unix(selectedCar.stan_gps_data).format(displayDateTimeFormat),
                    typ: selectedCar.typ,
                    adres: selectedCar.adres_gps ? selectedCar.adres_gps : 'Nie odkryto adresu',
                    dystans: selectedCar.dystans,
                    predkosc: selectedCar.predkosc
                }],
                center: center,
                selectedRoutes: selectedRoutes ? routesToExport : [],
                seletedRefuels: selectedRoutes ? refuelsToExport : [],
                currentRoute: currentRouteToExport,
                zoom: zoom,
            };
            generatedMap = generateMapForCars(properties);
        } else {
            const cars = filteredCars.map(car => ({
                pozycja_gps: car.pozycja_gps,
                rejestracja: car.rejestracja,
                marka: car.marka,
                model: car.model,
                stanPaliwa: car.stan_paliwa,
                stanPaliwaProcent: Math.round(car.stan_paliwa_procent * 100),
                typPaliwa: car.paliwo,
                ostatniaAktualizacja: moment.unix(car.stan_gps_data).format(displayDateTimeFormat),
                typ: car.typ,
                adres: car.adres_gps ? car.adres_gps : 'Nie odkryto adresu',
                dystans: car.dystans,
                predkosc: car.predkosc
            }));
            properties = {
                cars: cars,
                center: center,
                zoom: zoom,
            };
            generatedMap = generateMapForCars(properties);
        }


        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(generatedMap.documentElement.outerHTML));
        element.setAttribute('download', 'mapa.html');
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    const handleSearch = () => {
        if (!isNullOrEmpty(searchField)) {
            props.getCarsForMap(searchField);
            props.setSearchField("");
        }
        if (selectedCar !== null) {
            props.getRoutes(selectedCar.auto_id);
        }
    };

    return (
        <FiltersBar>
            <div className={classes.filterElement}>
                <DateTimePicker/>
            </div>
            <div className={classes.filterElement}>
                <Filter
                    onSearching={handleSearch}
                    isMap
                />
            </div>
            <div className={classes.filterElement}>
                <div className={classes.buttons}>
                    <Button
                        variant="contained"
                        size="small"
                        className={classes.button}
                        classes={{containedSecondary: classes.buttonDefault, label: classes.buttonLabel}}
                        startIcon={<TrackChangesIcon/>}
                        color={trackAll ? "primary" : "secondary"}
                        onClick={handleTrackAllCars}
                    >
                        {t.trackAll}
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        className={classes.button}
                        classes={{containedSecondary: classes.buttonDefault, label: classes.buttonLabel}}
                        startIcon={<MapIcon/>}
                        color={trackAll ? "primary" : "secondary"}
                        onClick={handleExportMap}
                    >
                        {t.exportMap}
                    </Button>
                </div>
            </div>
        </FiltersBar>
    )
        ;
};

const mapStateToProps = state => {
    return {
        trackAll: state.mapCarsReducer.trackAll,
        mapToBounds: state.mapReducer.mapToBounds,
        selectedCar: state.mapCarsReducer.selectedCar,
        cars: state.mapCarsReducer.cars,
        searchField: state.filterReducer.searchField,
        selectedRoutes: state.mapRoutesReducer.selectedRoutes,
        routes: state.mapRoutesReducer.routes,
        currentRoute: state.mapRoutesReducer.currentRoute,
        showCurrentRoute: state.mapRoutesReducer.showCurrentRoute,
    };
};

const useStyles = theme => ({
    filterElement: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start'
    },
    button: {
        margin: theme.spacing(0.5),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        [theme.breakpoints.down('lg')]: {
            marginBottom: 0,
        },
    },
    buttonLabel: {
        color: "#FFF",
        [theme.breakpoints.down('lg')]: {
            fontSize: "10px",
        },
    },
    buttonDefault: {
        background: themeTypeToBool(theme.palette.type) ? "#43425D" : theme.palette.primary.main
    },
    buttons: {
        display: "flex",
        flexDirection: "row",
    }
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    ),
    withStyles(useStyles),
    withRouter
)(TopBar);

TopBar.propTypes = {
    classes: PropTypes.object,
    history: PropTypes.object,
    filteredCars: PropTypes.array,
    zoom: PropTypes.number,
    center: PropTypes.object,
    selectedRoutes: PropTypes.array,
    routes: PropTypes.array,
    currentRoute: PropTypes.object,
    showCurrentRoute: PropTypes.bool,
    //redux
    trackAll: PropTypes.bool,
    selectedCar: PropTypes.object,
    cars: PropTypes.array,
    searchField: PropTypes.string,
    setSearchField: PropTypes.func,
    getCarsForMap: PropTypes.func,
    trackAllCars: PropTypes.func,
    clearRoutes: PropTypes.func,
    getCarsForMap: PropTypes.func,
    getRoutes: PropTypes.func,
    mapToBounds: PropTypes.func,
};
